import React from 'react';

// Skeleton specifically for just the recipe grid area when switching categories
export const RecipeGridSkeleton = () => (
  <div className="recipe-grid">
    {[1, 2, 3, 4, 5, 6].map(i => (
      <div key={i} className="recipe-card">
        <div style={{ padding: '20px' }}>
          <div className="recipe-header">
            <div style={{ flex: 1, paddingRight: '10px' }}>
              <div className="skeleton skeleton-text large" style={{ width: '80%', marginBottom: '10px' }}></div>
              <div className="skeleton skeleton-text" style={{ width: '60%' }}></div>
            </div>
            <div className="skeleton skeleton-circle" style={{ width: '24px', height: '24px' }}></div>
          </div>
          <div className="skeleton skeleton-text" style={{ width: '90%', marginTop: '10px' }}></div>
          <div className="skeleton skeleton-text" style={{ width: '70%' }}></div>
        </div>
      </div>
    ))}
  </div>
);

export default RecipeGridSkeleton;